import {pair} from "@/library/types/pair"
import {classNames} from "@/library/utilities/html"
import useAuth from "@/library/auth/_hook.auth"

type ActiveUserProps = {
    fullName?: string
    email?: string
    roundImage?: boolean
    pictureSrc?: string
}

export default function ActiveUser(
    {
        fullName,
        email,
        roundImage = true,
        pictureSrc
    }: ActiveUserProps
) {
    const {jwtData} = useAuth()

    const payload: {
        avatarUrl?: string
        name?: string
        email?: string
    } | undefined = jwtData?.payload

    if (!payload)
        return <></>

    const avatarUrl = pictureSrc ?? payload.avatarUrl
    const name = fullName ?? payload.name
    const theMail = email ?? payload.email

    return <div className="active-user">
        {avatarUrl && <div className={classNames("picture",
            pair("picture--round", roundImage)
        )}><img alt={`Bilde av ${name}`} src={avatarUrl}/></div>}
        <div className="name-email">
            <div className="name">{name}</div>
            <div className="email">{theMail}</div>
        </div>
    </div>
}
